__turbopack_context__.v({
  "container": "label-module-scss-module__wwAdOW__container",
  "decorLine": "label-module-scss-module__wwAdOW__decorLine",
  "icon": "label-module-scss-module__wwAdOW__icon",
  "large": "label-module-scss-module__wwAdOW__large",
  "slide": "label-module-scss-module__wwAdOW__slide",
});
